export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10286.7563a9d6.jpg";